import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

interface ButtonProps {
  selected: boolean;
  url: string;
  size?: number;
}

export default styled.button<ButtonProps>`
  cursor: normal;
  border: solid 1px white;
  outline: none;
  padding: 0;
  margin: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${({ size }) => (size ?? size ? `${size}px` : "120px")};
  width: ${({ size }) => (size ?? size ? `${size}px` : "120px")};
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  background: ${(props) => (props.selected ? "#17426e" : `url(${props.url})`)};
  background-size: cover;
  background-repeat: no-repeat;

  &:hover {
    box-shadow: -6px -8px 12px rgba(255, 255, 255, 0.25),
      6px 8px 12px rgba(255, 255, 255, 0.35);
  }

  @media screen and (min-width: ${DESKTOP}px) {
    font-size: 20px;
    cursor: pointer;
    height: ${({ size }) => (size ?? size ? `${size}px` : "177px")};
    width: ${({ size }) => (size ?? size ? `${size}px` : "177px")};
  }
`;
